import { render, staticRenderFns } from "./classificationList.vue?vue&type=template&id=c6aee21a"
import script from "./classificationList.vue?vue&type=script&lang=js"
export * from "./classificationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports